<template>
  <div>
    <b-row class="right-align"> </b-row>
    <div class="custom-search">
      <!-- advance search input -->
      <b-row>
        <b-col md="4">
          <b-form-group>
            <label>Pretraga po svim kolonama:</label>
            <b-form-input
              placeholder="Pretraži..."
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
          </b-form-group>
        </b-col>
        <b-col md="4"> </b-col>
        <b-col md="2" offset="2" class="col-bottom-margin-7 text-right">
          <b-form-group class="col-bottom-margin-7 ">
            <!-- ADD BUTTON -->
            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-primary"
              :to="{ name: 'CattleForm' }"
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">Dodaj grlo</span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <!-- table -->
    <vue-good-table
      ref="table"
      class="table full-width"
      :columns="columns"
      :rows="cattle"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
      @on-row-click="onRowClick"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <b-row>
            <b-col md="5">
              <!-- LINK BUTTON -->
              <b-button
                v-if="!props.row.fkDeviceId"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-success"
                :to="{
                  name: 'CattleDeviceForm',
                  query: { cowId: props.row.pkCowId },
                }"
              >
                <feather-icon icon="LinkIcon" class="mr-50" />
                <span class="align-middle">Poveži sa uređajem</span>
              </b-button>
              <!-- UNLINK BUTTON -->
              <b-button
                v-else
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-warning"
                @click="
                  unlinkDeviceConfirmDialog(props.row.pkCowId, props.row.name)
                "
              >
                <feather-icon icon="LinkIcon" class="mr-50" />
                <span class="align-middle">Otkači uređaj</span>
              </b-button></b-col
            >
            <b-col md="3"
              ><!-- EDIT BUTTON -->
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-primary"
                :to="{
                  name: 'CattleForm',
                  params: { id: props.row.pkCowId },
                }"
              >
                <feather-icon icon="EditIcon" class="mr-50" />
                <span class="align-middle">Izmijeni</span>
              </b-button></b-col
            >
            <b-col md="3">
              <!-- DELETE BUTTON -->
              <b-button
                v-if="props.row.canBeDeleted"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                v-b-tooltip.hover.v-danger
                title="Brisanje je dozvoljeno samo za grla za koja nema logovanih podataka"
                variant="flat-danger"
                @click="
                  deleteCowConfirmDialog(props.row.pkCowId, props.row.name)
                "
              >
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span class="align-middle">Obriši</span>
              </b-button></b-col
            >
          </b-row>
        </span>

        <span v-if="props.column.field === 'color'">
          <div
            :style="'background-color: ' + props.row.color"
            class="color-badge"
          ></div>
        </span>

        <!-- ALL OTHER COLUMNS -->
        <span
          v-else
          :class="props.column.field === 'pkDeviceId' ? 'bold-text' : ''"
        >
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Prikaži
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap">
              grla po stranici (ukupno <b>{{ props.total }}</b> grla)
            </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BRow,
  BCol,
  BButton,
  VBTooltip,
  BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import { mapState } from "vuex";

export default {
  components: {
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BButton,
    BBadge,
  },
  directives: { "b-tooltip": VBTooltip, Ripple },
  data() {
    return {
      pageLength: 5,
      dir: false,
      columns: [
        {
          label: "Ime",
          field: "name",
          width: "15%",
        },
        {
          label: "Boja",
          field: "color",
          width: "15%",
        },
        {
          label: "Broj naušnice",
          field: "earringNumber",
          width: "15%",
        },
        {
          label: "Uređaj",
          field: "fkDeviceId",
          width: "15%",
        },
        {
          label: "Akcije",
          field: "action",
        },
      ],
      rows: [],
      searchTerm: "",
    };
  },
  computed: {
    ...mapState({
      cattle: (state) => state.cattle.cattle,
    }),
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    store.dispatch("cattle/GET_ALL_CATTLE");
  },
  methods: {
    advanceSearch(val) {
      this.searchTerm = val;
    },
    onRowClick(params) {},
    unlinkDeviceConfirmDialog(cowId, cowName) {
      var $this = this;
      this.$bvModal
        .msgBoxConfirm(
          "Da li ste sigurni da želite da otkačite uređaj sa grla " +
            cowName +
            ".",
          {
            title: "Skidanje uređaja",
            size: "sm",
            okVariant: "warning",
            okTitle: "Da",
            cancelTitle: "Ne",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) $this.unlinkDevice(cowId, cowName);
        });
    },
    unlinkDevice(cowId, cowName) {
      var $this = this;
      store
        .dispatch("cattle/UNLINK_DEVICE", { cowId })
        .then((response) => {
          $this.$swal({
            position: "bottom-end",
            icon: "success",
            title: "Uređaj je uspješno otkačen sa grla " + cowName,
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          store.dispatch("cattle/GET_ALL_CATTLE");
        })
        .catch((error) => {});
    },
    deleteCowConfirmDialog(cowId, cowName) {
      var $this = this;
      this.$bvModal
        .msgBoxConfirm(
          "Da li ste sigurni da želite da obrišete grlo " + cowName + ".",
          {
            title: "Birsanje grla",
            size: "sm",
            okVariant: "danger",
            okTitle: "Da",
            cancelTitle: "Ne",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) $this.deleteCow(cowId, cowName);
        });
    },
    deleteCow(cowId, cowName) {
      var $this = this;
      store
        .dispatch("cattle/DELETE_COW", cowId)
        .then((response) => {
          $this.$swal({
            position: "bottom-end",
            icon: "success",
            title: "Grlo sa imenom " + cowName + " je uspješno obrisano!",
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          store.dispatch("cattle/GET_ALL_CATTLE");
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.col-bottom-margin-7 {
  margin-top: auto;
  margin-bottom: 7px;
}
.color-badge {
  border-radius: 5px;
  width: 50%;
  height: 20px;
  -webkit-box-shadow: 0 0 10px gray;
  box-shadow: 0 0 10px gray;
  opacity: 0.8;
}
.hidden {
  visibility: hidden;
}
</style>
